import React, { Fragment } from 'react';
import { Col, Button } from "reactstrap";
import { SelectForm } from "../../Basicos/index";

// Filtro genérico por Período Letivo / Semestre / Turma — filtra client-side sobre os `dados`
// já carregados, batendo direto nas colunas periodo_letivo_id/semestre_id/turma_id de cada
// registro. Os três são independentes entre si (sem encadeamento), então não precisa buscar
// opções dinamicamente como o FiltrosSemestre do unichristus-frontend faz pra turma.
const FiltrosPeriodoSemestreTurma = ({ novoOnClick, filtros, dados, setDadosFiltrados, valoresFiltro, setValoresFiltro }) => {
    const { periodos_letivos, semestres, turmas } = filtros || {};

    const periodosOptions = periodos_letivos && periodos_letivos.map(p => ({ value: p.id, label: p.descricao }));
    const semestresOptions = semestres && semestres.map(s => ({ value: s.id, label: s.descricao }));
    const turmasOptions = turmas && turmas.map(t => ({ value: t.id, label: t.descricao }));

    const style = {
        col: { xs: 12, md: 3, sm: 3, lg: 3, xl: 3 }
    }

    const onChangeSelect = (nome, valor) => {
        const novosValores = { ...valoresFiltro, [nome]: valor };
        setValoresFiltro(novosValores);

        let dadosFiltrados = dados || [];

        if (novosValores.periodo_letivo_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.periodo_letivo_id == novosValores.periodo_letivo_id);
        }
        if (novosValores.semestre_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.semestre_id == novosValores.semestre_id);
        }
        if (novosValores.turma_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.turma_id == novosValores.turma_id);
        }

        setDadosFiltrados(dadosFiltrados);
    }

    return (
        <Fragment>
            <SelectForm
                label="Período Letivo"
                name="periodo_letivo_id"
                placeholder="Período"
                options={periodosOptions}
                onChange={onChangeSelect}
                value={periodosOptions && periodosOptions.find(option => (option.value === valoresFiltro.periodo_letivo_id)) || ''}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Semestre"
                name="semestre_id"
                placeholder="Semestre"
                options={semestresOptions}
                onChange={onChangeSelect}
                value={semestresOptions && semestresOptions.find(option => (option.value === valoresFiltro.semestre_id)) || ''}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Turma"
                name="turma_id"
                placeholder="Turma"
                options={turmasOptions}
                onChange={onChangeSelect}
                value={turmasOptions && turmasOptions.find(option => (option.value === valoresFiltro.turma_id)) || ''}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />

            <Col className="d-flex align-items-end mb-3" md={3} sm={12}>
                <Button className="mr-3 py-2 btn-secondary"
                    onClick={() => {
                        setValoresFiltro({
                            periodo_letivo_id: undefined,
                            semestre_id: undefined,
                            turma_id: undefined
                        });
                        setDadosFiltrados(dados);
                    }}>Limpar</Button>
                <Button className="py-2 btn-primary" onClick={novoOnClick}>Novo</Button>
            </Col>
        </Fragment>
    )
}

export default FiltrosPeriodoSemestreTurma;
